const STORAGE_KEY = {
  KNOWLEDGE_BASE_PAGE: 'KNOWLEDGE_BASE_PAGE',
  ANALYTICS_PAGE: 'ANALYTICS_PAGE',
} as const;

export const getPageConfig = (
  key: string,
  storage: Storage = localStorage,
): Record<string, unknown> => {
  return JSON.parse(storage.getItem(key) || '{}');
};

export const setPageConfig = (
  key: string,
  config: Record<string, unknown>,
  storage: Storage = localStorage,
): void => {
  const storageConfig = getPageConfig(key);

  storage.setItem(
    key,
    JSON.stringify({
      ...storageConfig,
      ...config,
    }),
  );
};

export const getKnowledgeBaseConfig = (): Record<string, unknown> => {
  const { KNOWLEDGE_BASE_PAGE } = STORAGE_KEY;
  const storageConfig = getPageConfig(KNOWLEDGE_BASE_PAGE) as Record<
    string,
    Record<string, unknown>
  >;

  return (
    (storageConfig[storageConfig.knowledgeBaseId as unknown as string] as Record<
      string,
      unknown
    >) || {}
  );
};

export const setKnowledgeBaseConfig = (config: Record<string, unknown>): void => {
  const { KNOWLEDGE_BASE_PAGE } = STORAGE_KEY;
  const storageConfig = getPageConfig(KNOWLEDGE_BASE_PAGE) as Record<string, unknown>;
  const id = (config.knowledgeBaseId || storageConfig.knowledgeBaseId) as string;
  const newConfig = {
    ...storageConfig,
    [id]: {
      ...(storageConfig[id] as Record<string, unknown>),
      ...config,
    },
    knowledgeBaseId: id,
  };

  localStorage.setItem(KNOWLEDGE_BASE_PAGE, JSON.stringify(newConfig));
};
